import toast from 'react-hot-toast'
import api from '../../services/api'

// The dashboard's CSV, through the shared api instance with the exact params
// the screen was loaded with, so the file is cut to the same range. A plain
// <a href> would skip the session handling in services/api.js. The backend
// decides the columns (per channel and sub_id; the split columns for a
// partner under an agreement) and always leaves test leads out.
export async function downloadDashboardCsv(params, range) {
  try {
    const response = await api.get('/partner/dashboard/sub-ids.csv', { params, responseType: 'blob' })
    const disposition = response.headers?.['content-disposition'] || ''
    const match = /filename="?([^";]+)"?/.exec(disposition)
    const filename = match ? match[1] : `sub-ids-${range?.date_from || ''}-to-${range?.date_to || ''}.csv`
    const blob = response.data instanceof Blob ? response.data : new Blob([response.data], { type: 'text/csv' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = filename
    document.body.appendChild(a)
    a.click()
    a.remove()
    URL.revokeObjectURL(url)
  } catch {
    toast.error('Export failed - try again')
  }
}
